import { AuthService } from '@anecdotes/auth-core';
import { MonitoringService } from '@anecdotes/monitoring';
import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-role',
  templateUrl: './no-role.component.html',
})
export class NoRoleComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex w-full h-full items-center justify-center';

  constructor(private authService: AuthService, private monitoringService: MonitoringService) {}

  ngOnInit(): void {
    this.monitoringService.sendEvent('User login without role');
  }

  logout(): void {
    this.authService.signOutAsync({});
  }
}
